<template>
    <div class="flex flex justify-center inline-block">
        <div class="text-xs ">
            <span>Powered by: </span> <a class="font-bold" target="_blank" href="https://mooncake.pl">MOONCAKE</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "PoweredBy"
}
</script>

<style scoped>

</style>
